import React, { useState } from 'react';
import api from '../../api';
import toast from 'react-hot-toast';


export const Login = ( {setToken} ) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [password, setPassword] = useState("");
  const [datasetId, setDatasetId] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    const toastId = toast.loading("Submitting..");
    api.post(
      "/submit/token",
      {
        username: datasetId,
        password: password,
      }, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }
    ).then(response => {
        setToken(`Bearer ${response.data.access_token}`);
        setIsLoggedIn(true);
        toast.success("Sucessfully logged in!", {id: toastId})
      }
    ).catch(e => {
        toast.error("Authentication failed!", {id: toastId})
        setToken(null);
        setIsLoggedIn(false);
      })
    };


  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3 card card-body">
        <label htmlFor="rawFile" className="form-label">
          Raw file containing the lipid profile
        </label>
        <div className="input-group">
            <input type="text" class="form-control" id="datasetIdInput" placeholder="datasetId" onChange={e => setDatasetId(e.target.value)} />
            <input type="password" class="form-control" id="inputPassword" placeholder="password" onChange={e => setPassword(e.target.value)} />
          <LoginButton isLoggedIn={isLoggedIn} disabled={password.length === 0 || datasetId.length === 0}/>
          </div>
      </div>
    </form>
  )

}


function LoginButton( {isLoggedIn, disabled} ) {
  if (isLoggedIn) {
    return <button type='submit' className="btn btn-success">Logged in</button>
  }
  return <button className="btn btn-primary" type='submit' disabled={disabled}>Log in</button>
}
